import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';

/* actions */
import * as Actions from '../../redux/actions';

class cleanUserSearchHistory extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'clean User Search History';
        this.Config   = new AppConfig();
        this.payload  = null;
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.cleanUserSearchHistory);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState() {
        AnalyticsManager.updateUserProperties(this.response.data);
        this.dispatch(Actions.setUserData(this.response.data));
    }
}


export default cleanUserSearchHistory;
